import angular from 'angular';
import _ from 'lodash';

export default angular.module('retailer-dashboards-errorcodes', []).run([
  'gettextCatalog',
  'appFactory',
  function errorCodes(gettextCatalog, appFactory) {
    appFactory.deps.config.errorCodes = _.merge(appFactory.deps.config.errorCodes, {
      retailerDashboards: {
        ENTITY_NOT_FOUND: () => ({ title: gettextCatalog.getString('Sorry, no results were found.') }),
        RETAILER_NOT_FOUND: () => ({ title: gettextCatalog.getString('Sorry, no results were found.') }),
      },
    });
  },
]);



// WEBPACK FOOTER //
// ./src/modules/retailer-dashboards/config/errorcodes.conf.js